import React from 'react';

import {Icon, Icons, Sizes} from '@pb/kit-component-icon';

import {removeButton} from './remove-button.module.styl';

type Props = {
    handler: () => void,
};

export const RemoveIcon: React.FC<Props> = ({handler}) => (
    <span className={removeButton}>
        <Icon type={Icons.CLOSE} size={Sizes.Size_19} onClick={handler}/>
    </span>
);
